/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonTagItemViewModel } from "../types/PersonTagItemViewModel.ts";

export const personTagItemViewModelSchema = z.object({
  id: z.optional(
    z
      .number()
      .int()
      .describe("Identificador único do vínculo entre a pessoa e a tag."),
  ),
  tagId: z.optional(z.number().int().describe("ID da tag associada à pessoa.")),
  creationDate: z
    .string()
    .datetime()
    .describe("Data em que a tag foi vinculada à pessoa. Opcional.")
    .nullish(),
}) as unknown as ToZod<PersonTagItemViewModel>;
